import { action, computed, observable } from 'mobx';
import { authApi } from '@/services';
import { Area } from '@/services/const';

const storage = localStorage;
const ACCESS_TOKEN = 'accessToken';
const REFRESH_TOKEN = 'refreshToken';
const AREA = 'area';

export class Auth {
  @observable accessor accessToken = storage.getItem(ACCESS_TOKEN) || '';
  @observable accessor refreshToken = storage.getItem(REFRESH_TOKEN) || '';
  @observable accessor area: Area =
    (storage.getItem(AREA) as Area) || Area.Osaka;

  @action
  setAccessToken(accessToken?: string) {
    if (accessToken) {
      this.accessToken = accessToken;
      storage.setItem(ACCESS_TOKEN, accessToken);
    }
  }

  @action
  setRefreshToken(refreshToken?: string) {
    if (refreshToken) {
      this.refreshToken = refreshToken;
      storage.setItem(REFRESH_TOKEN, refreshToken);
    }
  }

  @action
  setArea(area: Area) {
    this.area = area;
    storage.setItem(AREA, area);
  }

  @action
  async refreshExpiredToken() {
    return authApi
      .refresh({
        body: {
          refreshToken: this.refreshToken
        }
      })
      .then(res => {
        if (res.accessToken) {
          this.setAccessToken(res.accessToken);
        }
        if (res.refreshToken) {
          this.setRefreshToken(res.refreshToken);
        }
        return res.accessToken;
      });
  }

  @action
  getAccessToken() {
    return this.accessToken;
  }

  @action
  logout() {
    this.accessToken = '';
    this.refreshToken = '';
    this.area = Area.Osaka;
    storage.removeItem(ACCESS_TOKEN);
    storage.removeItem(REFRESH_TOKEN);
    storage.removeItem(AREA);
  }

  @computed
  get loggedIn(): boolean {
    return !!this.accessToken;
  }

  @computed
  get isOsaka(): boolean {
    return this.area === Area.Osaka;
  }

  @computed
  get isTokyo(): boolean {
    return this.area === Area.Tokyo;
  }
}

export default new Auth();
